import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Breadcrumbs } from '@mui/material';
import RequestStartUpForm from './RequestStartUpForm';
import { getUser } from '../../Services/config/globals';
import { requestStartUp } from '../../Services/Utils/RequestStartupApis';
import { notifySet } from '../../Services/Actions/CommonActions';

function RequestStartup() {
  const user = getUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSubmit = (formData) => {
    const data = {
      categoryView: {
        id: formData.serviceCategory.id
      },
      serviceProviderName: formData.servicePartnerName,
      websites: formData.websiteURL,
      contactDetails: formData.contactDetails,
      remarks: formData.remark
    };
    requestStartUp(data).then((res) => {
      const { message, hasError } = res;
      if (hasError === false) {
        navigate(-1);
        dispatch(notifySet({ type: 'success', message: 'Your request has been submitted, we are reviewing the same.' }));
      } else if (hasError === true) {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };
  return (
    <div>
      {user.view.roleView.id === 1 ? (
        <div className="breadcrumb-menu-con">
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
          >
            <Link to="/support-list">Support</Link>
            <Link to="#">Add Request</Link>
          </Breadcrumbs>
        </div>
      ) : (
        ''
      )}
      <RequestStartUpForm
        onSubmit={onSubmit}
        SubmitText="Submit"
        mainText="Support"
        action="add"
      />
    </div>
  );
}

export default RequestStartup;
